import React from "react";

const DetailPageTitle = ({ title, onBack }) => (
  <div className="middle-sidebar__title-wrapper no-bg-title detail-page-title">
    <div
      className="select-transport__back detail-page-title__back"
      onClick={onBack}
    >
      <div className="select-transport__back__icon detail-page-title__back-icon"></div>
    </div>
    <h3 className="middle-sidebar__title mobile-centered-title">
      {title}
    </h3>
  </div>
);

export default DetailPageTitle;
